// extracted by mini-css-extract-plugin
export default {"container":"OnBQJ8wn3mPJik68bz61a","info":"_3vHW-mOw7HUUW9TepTol3O","accordionState":"_2Nd9c-o_MKAeuyXICJn7mb"};